<h2 mat-dialog-title>Confirm</h2>
<mat-dialog-content>{{confirmMessage}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="confirm-btn" (click)="dialogRef.close(true)" aria-label="Confirm">Confirm</button>
  <button mat-button (click)="dialogRef.close(false)" aria-label="Cancel">Cancel</button>
</mat-dialog-actions>